<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
      <span
        v-if="tooltip"
        class="a-tooltip-secondary a-tooltip-top margin-left-xsmall font-size-small text-color-black-35"
        :data-tooltip-text="tooltip"
      >
        <i class="fas fa-info-circle"></i>
      </span>
    </label>
    <span
      :class="inputError ? 'a-select-primary a-select-primary-danger' : 'a-select-primary'"
    >
      <select
        v-bind="$attrs"
        v-on="listeners"
        :ref="reference"
        @change="updateValue"
      >
        <option
          selected
          value=""
        >
        </option>
        <option
          v-for="element in elements"
          :key="element[keyField]"
          :value="element[keyField]"
          :selected="element[keyField] === value ? true : false"
        >
          {{ element[textField] }}
        </option>
      </select>
      <span class="arrow">
        <i class="far fa-chevron-down"></i>
      </span>
    </span>
    <small
      v-if="!inputError && message"
      class="font-weight-light margin-top-xsmall"
    >
      <i>{{ message }}</i>
    </small>
    <small
      v-if="inputError"
      class="text-color-danger margin-top-xsmall"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomSelectPrimary',
  inheritAttrs: false,

  props: {
    elements: Array,
    inputError: Boolean,
    keyField: String,
    label: String,
    message: String,
    messageError: String,
    inputClass: String,
    reference: String,
    textField: String,
    tooltip: String,
    value: [String, Number],
    wrapperClass: String
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
